import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_hjv6mwysyg: FaireBrandEntity = {
  token: "b_hjv6mwysyg",
  type: "brand",
  name: "Doc Willard’s",
  avatarUrl:
    "https://cdn.faire.com/fastly/4f91ca2e58d8033455c6671d94245963925dbd836f55af4ee54995898e33eee1.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d64208d6298dc060a5cb29bfaeb6a6da1e26bd1e679cbe656419817c9941b6cd.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/4f91ca2e58d8033455c6671d94245963925dbd836f55af4ee54995898e33eee1.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d64208d6298dc060a5cb29bfaeb6a6da1e26bd1e679cbe656419817c9941b6cd.jpeg",
  location: "Raleigh, NC, USA",
  minimumOrderDollars: 69,
  rating: 5,
  reviewCount: 3,
  isInsider: true,
  description:
    "Andrew and Carol are the crafters behind all of the curations. We are world travelers and lovers of all of Earth's gifts. All of our crystals are handpicked by us and the gift sets are all made by hand. The metaphysical world has afforded us the opportunity to connect to our spiritual side and the metaphysical community.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:34.402Z",
    importedBy: "entity-db-cli",
  },
};
